import React from 'react';
import styles from './styles/whyQuattron.module.css';

export default function WhyQuattron() {
  return (
    <section className={styles.whyQuattron}>
      <h2>Why Families Choose PenguinLearn</h2>
      <div className={styles.whyContainer}>
        <div className={styles.whyItem}>
          <h3>Wide Choice of Live Classes</h3>
          <p>
            Browse subjects and teachers; pick the style, time, and price that fit.
          </p>
        </div>

        <div className={styles.whyItem}>
          <h3>Vetted Teachers, Real Reviews</h3>
          <p>
            Background-checked instructors with ratings and clear pricing—book with confidence.
          </p>
        </div>

        <div className={styles.whyItem}>
          <h3>Pay-as-you-go</h3>
          <p>
            Only pay for the classes you take — no monthly fees, no marketplace fee. Perfect for busy families.
          </p>
        </div>
      </div>
    </section>
  );
}
